import { ZengularNotification } from "zengular-ui";
export default function modalError() {
  var messages = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return function (target) {
    target.prototype.errorMessages = messages;

    target.prototype.handleError = function (error) {
      var _this = this;

      var icon = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'fas fa-sad-tear';

      if (error !== false) {
        this.shake();
        if (!Array.isArray(error)) error = [error];
        error.forEach(function (error) {
          _this.$('[data-error=\"' + error + '\"]').each(function (node) {
            return node.classList.add('visible');
          });

          var message = typeof _this.errorMessages[error] === 'string' ? _this.errorMessages[error] : error;
          ZengularNotification.show('danger', icon, message);
        });
        return Promise.reject(false);
      }
    };

    target.prototype.handleXhr = function (xhr) {
      return xhr.status === 200 ? xhr : this.handleError(typeof xhr.response.error === "string" ? xhr.response.error : 'Some error occured!');
    };

    target.prototype.okay = function () {
      var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'Okay!';
      ZengularNotification.show('success', "fal fa-thumbs-up", message);
    };

    target.prototype.reset = function () {
      this.$('[data-error]').each(function (node) {
        return node.classList.remove('visible');
      });
    };
  };
}